/** English message catalogue. Add further locales as sibling files with the same keys. */
export const en = {
  'app.skipToContent': 'Skip to main content',
  'nav.primary': 'Primary navigation',
  'nav.open': 'Open navigation menu',
  'nav.close': 'Close navigation menu',
  'nav.dashboard': 'Dashboard',
  'nav.users': 'Users',
  'nav.audit': 'Audit log',
  'breadcrumb.label': 'Breadcrumb',
  'breadcrumb.home': 'Home',
  'dashboard.title': 'Dashboard',
  'dashboard.welcome': 'Welcome to {product}',
  'dashboard.hello': 'Signed in as {name}',
  'status.title': 'System status',
  'status.loading': 'Checking system status…',
  'status.error': 'Unable to reach the server.',
  'status.retry': 'Retry',
  'status.ok': 'All systems operational',
  'status.degraded': 'Some services are unavailable',
  'status.database': 'Database',
  'status.redis': 'Cache',
  'status.up': 'Up',
  'status.down': 'Down',
  'notfound.title': 'Page not found',
  'notfound.body': 'The page you are looking for does not exist.',
  'notfound.back': 'Back to dashboard',
  'forbidden.title': 'Access denied',
  'forbidden.body': 'You do not have permission to view this page.',

  'auth.loading': 'Loading…',
  'auth.signIn': 'Sign in',
  'auth.signingIn': 'Signing in…',
  'auth.signOut': 'Sign out',
  'auth.identifier': 'Email or username',
  'auth.password': 'Password',
  'auth.invalid': 'Invalid email/username or password.',
  'auth.rateLimited': 'Too many attempts. Please wait a minute and try again.',
  'auth.genericError': 'Something went wrong. Please try again.',
  'auth.forgot': 'Forgot your password?',
  'auth.forgotTitle': 'Reset your password',
  'auth.forgotIntro': 'Enter your email and we will send you a reset link.',
  'auth.email': 'Email',
  'auth.sendLink': 'Send reset link',
  'auth.forgotSent': 'If that email is registered, a reset link has been sent.',
  'auth.backToSignIn': 'Back to sign in',
  'auth.resetTitle': 'Choose a new password',
  'auth.newPassword': 'New password',
  'auth.passwordHint':
    'At least 12 characters, with a letter and a digit. A common word, a keyboard run or your own name will be refused; a few unrelated words work well.',
  'auth.resetSubmit': 'Set password',
  'auth.resetDone': 'Password updated. You can now sign in.',
  'auth.resetInvalid': 'This link is invalid or has expired.',
  'auth.userMenu': 'Account',

  'users.title': 'Users',
  'users.search': 'Search users',
  'users.searchPlaceholder': 'Name, email or username',
  'users.add': 'Add user',
  'users.cancel': 'Cancel',
  'users.name': 'Name',
  'users.email': 'Email',
  'users.roles': 'Roles',
  'users.status': 'Status',
  'users.actions': 'Actions',
  'users.active': 'Active',
  'users.disabled': 'Disabled',
  'users.disable': 'Disable',
  'users.enable': 'Enable',
  'users.confirmDisable': 'Disable {name}? They will be signed out immediately.',
  'users.empty': 'No users found.',
  'users.loading': 'Loading users…',
  'users.error': 'Could not load users.',
  'users.fullName': 'Full name',
  'users.initialPassword': 'Initial password',
  'users.create': 'Create user',
  'users.creating': 'Creating…',
  'users.created': 'User created.',
  'users.emailTaken': 'That email is already in use.',
  'users.noRoles': '—',
  'users.page': 'Page {page} of {total}',
  'users.prev': 'Previous',
  'users.next': 'Next',

  'audit.title': 'Audit log',
  'audit.when': 'When',
  'audit.action': 'Action',
  'audit.entity': 'Entity',
  'audit.user': 'User',
  'audit.ip': 'IP address',
  'audit.empty': 'No audit entries.',
  'audit.loading': 'Loading audit log…',
  'audit.error': 'Could not load the audit log.',
  'audit.filterAction': 'Filter by action',

  'nav.schools': 'Schools',
  'nav.settings': 'Settings',
  'nav.organization': 'Organization',

  'common.save': 'Save',
  'common.saving': 'Saving…',
  'common.saved': 'Saved.',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.add': 'Add',
  'common.loading': 'Loading…',
  'common.loadError': 'Could not load this page.',
  'common.actionError': 'The action failed. Please try again.',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.confirmDelete': 'Delete {name}? This cannot be undone.',

  'org.title': 'Organization',
  'org.name': 'Organization name',
  'org.timezone': 'Time zone',
  'org.currency': 'Currency (ISO code)',
  'org.slug': 'Identifier',

  'schools.title': 'Schools',
  'schools.add': 'Add school',
  'schools.empty': 'No schools yet.',
  'schools.name': 'Name',
  'schools.code': 'Code',
  'schools.city': 'City',
  'schools.status': 'Status',
  'schools.codeHint': 'Short unique code, e.g. NORTH-1',
  'schools.create': 'Create school',
  'schools.created': 'School created.',
  'schools.back': 'All schools',
  'schools.details': 'School details',
  'schools.country': 'Country (2-letter code)',
  'schools.phone': 'Phone',
  'schools.email': 'Email',
  'schools.language': 'Language',

  'campuses.title': 'Campuses',
  'campuses.add': 'Add campus',
  'campuses.empty': 'No campuses yet.',
  'campuses.main': 'Main',
  'campuses.makeMain': 'Make main',

  'years.title': 'Academic years',
  'years.add': 'Add academic year',
  'years.empty': 'No academic years yet.',
  'years.name': 'Name',
  'years.start': 'Start date',
  'years.end': 'End date',
  'years.current': 'Current',
  'years.makeCurrent': 'Make current',
  'years.currentOnCreate': 'Make this the current year',

  'settings.title': 'Settings',
  'settings.scope': 'Settings for',
  'settings.scopeOrg': 'Whole organization',
  'settings.source.default': 'Default',
  'settings.source.organization': 'From organization',
  'settings.source.school': 'School override',
  'settings.reset': 'Reset to inherited value',
  'settings.preview': 'Preview: {value}',
  'settings.weekday.0': 'Sun',
  'settings.weekday.1': 'Mon',
  'settings.weekday.2': 'Tue',
  'settings.weekday.3': 'Wed',
  'settings.weekday.4': 'Thu',
  'settings.weekday.5': 'Fri',
  'settings.weekday.6': 'Sat',
  'nav.students': 'Students',
  'nav.admissions': 'Admissions',
  'nav.staff': 'Staff',
  'nav.myChildren': 'My children',

  'school.select': 'School',
  'school.none': 'No schools available.',

  'students.title': 'Students',
  'students.add': 'Add student',
  'students.empty': 'No students found.',
  'students.admissionNo': 'Admission no.',
  'students.class': 'Class',
  'students.allClasses': 'All classes',
  'students.allStatuses': 'All statuses',
  'students.searchLabel': 'Search students',
  'students.firstName': 'First name',
  'students.lastName': 'Last name',
  'students.dob': 'Date of birth',
  'students.gender': 'Gender',
  'students.gender.male': 'Male',
  'students.gender.female': 'Female',
  'students.gender.other': 'Other',
  'students.gender.undisclosed': 'Prefer not to say',
  'students.section': 'Section',
  'students.noSection': 'No section',
  'students.notEnrolled': 'Not enrolled',
  'students.create': 'Register student',
  'students.created': 'Student registered.',
  'students.duplicate':
    'A student with the same name and date of birth already exists. Register anyway?',
  'students.status.active': 'Active',
  'students.status.transferred': 'Transferred',
  'students.status.graduated': 'Graduated',
  'students.status.alumni': 'Alumni',
  'students.status.inactive': 'Inactive',
  'students.export': 'Export CSV',
  'students.import': 'Import CSV',
  'students.importHelp':
    'Required columns: first_name, last_name, date_of_birth (YYYY-MM-DD), gender. Optional: class, section, roll_number, guardian_first_name, guardian_last_name, guardian_email, guardian_relationship and more.',
  'students.importFile': 'CSV file',
  'students.validate': 'Validate only',
  'students.runImport': 'Import',
  'students.importOk': '{count} students ready to import.',
  'students.importDone': 'Imported {count} students.',
  'students.importErrors': 'Nothing was imported. Fix these rows and try again:',
  'students.row': 'Row {row}',
  'students.profile': 'Profile',
  'students.medical': 'Medical notes',
  'students.house': 'House',
  'students.enrollment': 'Enrollment (current year)',
  'students.saveEnrollment': 'Save enrollment',
  'students.rollNumber': 'Roll number',
  'students.changeStatus': 'Change status',
  'students.statusReason': 'Reason (optional)',
  'students.guardians': 'Parents / guardians',
  'students.noGuardians': 'No parents or guardians linked.',
  'students.addGuardian': 'Add parent / guardian',
  'students.relationship': 'Relationship',
  'students.primary': 'Primary',
  'students.emergency': 'Emergency contact',
  'students.unlink': 'Unlink',
  'students.phone': 'Phone',
  'students.email': 'Email',
  'students.back': 'All students',

  'adm.title': 'Admissions',
  'adm.enquiries': 'Enquiries',
  'adm.applications': 'Applications',
  'adm.newEnquiry': 'New enquiry',
  'adm.newApplication': 'New application',
  'adm.studentName': 'Student name',
  'adm.parentName': 'Parent name',
  'adm.phone': 'Phone',
  'adm.interestedClass': 'Interested in class',
  'adm.source': 'Source',
  'adm.status': 'Status',
  'adm.number': 'Number',
  'adm.empty': 'Nothing here yet.',
  'adm.save': 'Save',
  'adm.guardianFirst': 'Parent first name',
  'adm.guardianLast': 'Parent last name',
  'adm.guardianEmail': 'Parent email',
  'adm.academicYear': 'Academic year',
  'adm.applyClass': 'Applying for class',
  'adm.note': 'Note',
  'adm.admit': 'Admit',
  'adm.admitted': 'Admitted — admission number {number}.',
  'adm.notePrompt': 'Reason for rejection:',
  'adm.action.contacted': 'Mark contacted',
  'adm.action.application_issued': 'Application issued',
  'adm.action.closed': 'Close',
  'adm.action.new': 'Reopen',
  'adm.action.under_review': 'Start review',
  'adm.action.approved': 'Approve',
  'adm.action.rejected': 'Reject',
  'adm.action.submitted': 'Back to submitted',
  'adm.status.new': 'New',
  'adm.status.contacted': 'Contacted',
  'adm.status.application_issued': 'Application issued',
  'adm.status.closed': 'Closed',
  'adm.status.submitted': 'Submitted',
  'adm.status.under_review': 'Under review',
  'adm.status.approved': 'Approved',
  'adm.status.rejected': 'Rejected',
  'adm.status.admitted': 'Admitted',

  'staff.title': 'Staff',
  'staff.add': 'Add staff member',
  'staff.number': 'Employee no.',
  'staff.designation': 'Designation',
  'staff.type': 'Type',
  'staff.teaching': 'Teaching',
  'staff.non_teaching': 'Non-teaching',
  'staff.empty': 'No staff found.',
  'staff.created': 'Staff member created.',

  'portal.title': 'My children',
  'portal.empty': 'No children are linked to your account yet.',
  'nav.academics': 'Academics',
  'nav.myClasses': 'My classes',

  'acad.title': 'Academics',
  'acad.tab.classes': 'Classes & sections',
  'acad.tab.subjects': 'Subjects',
  'acad.tab.terms': 'Terms',
  'acad.tab.houses': 'Houses',
  'acad.tab.teaching': 'Teaching',
  'acad.tab.calendar': 'Calendar',
  'acad.name': 'Name',
  'acad.code': 'Code',
  'acad.type': 'Type',
  'acad.add': 'Add',
  'acad.delete': 'Delete',
  'acad.stream': 'Stream',
  'acad.noStream': 'No stream',
  'acad.addClass': 'Add class',
  'acad.addSection': 'Add section',
  'acad.addStream': 'Add stream',
  'acad.sections': 'Sections',
  'acad.noClasses': 'No classes yet.',
  'acad.addSubject': 'Add subject',
  'acad.noSubjects': 'No subjects yet.',
  'acad.classSubjects': 'Subjects for class',
  'acad.saveSubjects': 'Save subjects',
  'acad.optional': 'optional',
  'acad.core': 'Core',
  'acad.elective': 'Elective',
  'acad.co_curricular': 'Co-curricular',
  'acad.currentYear': 'Current academic year',
  'acad.noYear': 'This school has no current academic year. Set one first.',
  'acad.addTerm': 'Add term',
  'acad.noTerms': 'No terms yet.',
  'acad.start': 'Start',
  'acad.end': 'End',
  'acad.addHouse': 'Add house',
  'acad.noHouses': 'No houses yet.',
  'acad.colour': 'Colour',
  'acad.classTeachers': 'Class teachers',
  'acad.subjectTeachers': 'Subject teachers',
  'acad.teacher': 'Teacher',
  'acad.section': 'Section',
  'acad.subject': 'Subject',
  'acad.assign': 'Assign',
  'acad.noAssignments': 'No assignments yet.',
  'acad.noTeacher': 'Not assigned',
  'acad.addEvent': 'Add event',
  'acad.noEvents': 'No events yet.',
  'acad.eventTitle': 'Title',
  'acad.holiday': 'Holiday',
  'acad.exam': 'Exam',
  'acad.event': 'Event',
  'acad.meeting': 'Meeting',
  'acad.break': 'Break',
  'myclasses.title': 'My classes',
  'myclasses.empty': 'You have no classes assigned this year.',
  'myclasses.classTeacher': 'Class teacher',
  'myclasses.students': '{count} students',
  'myclasses.viewStudents': 'View students',
  'nav.attendance': 'Attendance',
  'nav.timetable': 'Timetable',
  'nav.myTimetable': 'My timetable',
  'nav.leave': 'Leave requests',
  'att.title': 'Attendance',
  'att.date': 'Date',
  'att.summary': 'Sections',
  'att.section': 'Section',
  'att.classTeacher': 'Class teacher',
  'att.students': 'Students',
  'att.state': 'Register',
  'att.submitted': 'Submitted',
  'att.notSubmitted': 'Not submitted',
  'att.open': 'Open register',
  'att.noSections': 'No sections to show for this date.',
  'att.registerFor': 'Register: {section}',
  'att.roll': 'Roll',
  'att.student': 'Student',
  'att.status': 'Status',
  'att.remarks': 'Remarks',
  'att.statusFor': 'Status for {name}',
  'att.remarksFor': 'Remarks for {name}',
  'att.onLeave': 'Approved leave',
  'att.markAllPresent': 'Mark all present',
  'att.submit': 'Submit register',
  'att.saveChanges': 'Save corrections',
  'att.reason': 'Reason for the change',
  'att.saved': 'Register saved.',
  'att.readOnly': 'This register is read-only for you.',
  'att.noStudents': 'No active students in this section.',
  'att.pickSection': 'Choose a section to open its register.',
  'att.status.present': 'Present',
  'att.status.absent': 'Absent',
  'att.status.late': 'Late',
  'att.status.excused': 'Excused',
  'att.status.half_day': 'Half day',
  'att.status.unmarked': 'Unmarked',
  'att.history': 'Attendance',
  'att.percentage': 'Attendance rate',
  'att.range': 'Last 30 days',
  'att.noRecords': 'No attendance recorded in this period.',
  'att.date.col': 'Date',
  'tt.title': 'Timetable',
  'tt.mine': 'My timetable',
  'tt.empty': 'No lessons scheduled.',
  'tt.noPeriods': 'No periods have been set up yet.',
  'tt.section': 'Section',
  'tt.teacher': 'Teacher',
  'tt.viewBySection': 'By section',
  'tt.viewByTeacher': 'By teacher',
  'tt.periods': 'Periods',
  'tt.periodName': 'Name',
  'tt.start': 'Start',
  'tt.end': 'End',
  'tt.isBreak': 'Break',
  'tt.addPeriod': 'Add period',
  'tt.deletePeriod': 'Delete',
  'tt.lesson': 'Add lesson',
  'tt.day': 'Day',
  'tt.period': 'Period',
  'tt.subject': 'Subject',
  'tt.room': 'Room',
  'tt.addLesson': 'Add lesson',
  'tt.removeLesson': 'Remove lesson',
  'tt.choose': 'Choose…',
  'tt.day.0': 'Sunday',
  'tt.day.1': 'Monday',
  'tt.day.2': 'Tuesday',
  'tt.day.3': 'Wednesday',
  'tt.day.4': 'Thursday',
  'tt.day.5': 'Friday',
  'tt.day.6': 'Saturday',
  'leave.title': 'Leave requests',
  'leave.student': 'Student',
  'leave.dates': 'Dates',
  'leave.reason': 'Reason',
  'leave.status': 'Status',
  'leave.approve': 'Approve',
  'leave.reject': 'Reject',
  'leave.note': 'Note to parent (optional)',
  'leave.empty': 'No leave requests.',
  'leave.all': 'All',
  'leave.status.pending': 'Pending',
  'leave.status.approved': 'Approved',
  'leave.status.rejected': 'Rejected',
  'leave.status.cancelled': 'Cancelled',
  'leave.request': 'Request leave',
  'leave.from': 'From',
  'leave.to': 'To',
  'leave.send': 'Send request',
  'leave.cancel': 'Cancel request',
  'leave.sent': 'Leave request sent.',
  'leave.mine': 'Leave requests',
  'child.back': 'Back to my children',
  'child.tab.attendance': 'Attendance',
  'child.tab.timetable': 'Timetable',
  'child.tab.leave': 'Leave',
  'child.open': 'Attendance, timetable and leave',
  'nav.exams': 'Exams',
  'nav.marks': 'Marks',
  'exam.title': 'Exams',
  'exam.tab.exams': 'Exams',
  'exam.tab.grading': 'Grading scales',
  'exam.tab.results': 'Results',
  'exam.name': 'Exam name',
  'exam.type': 'Type',
  'exam.type.unit_test': 'Unit test',
  'exam.type.term': 'Term exam',
  'exam.type.final': 'Final exam',
  'exam.type.practical': 'Practical',
  'exam.type.other': 'Other',
  'exam.start': 'Start date',
  'exam.end': 'End date',
  'exam.scale': 'Grading scale',
  'exam.create': 'Create exam',
  'exam.none': 'No exams yet.',
  'exam.open': 'Open',
  'exam.status': 'Status',
  'exam.status.draft': 'Draft',
  'exam.status.scheduled': 'Scheduled',
  'exam.status.marking': 'Marking',
  'exam.status.verified': 'Verified',
  'exam.status.published': 'Published',
  'exam.papers': 'Papers',
  'exam.noPapers': 'No papers scheduled yet.',
  'exam.paper.class': 'Class',
  'exam.paper.subject': 'Subject',
  'exam.paper.date': 'Date',
  'exam.paper.max': 'Max marks',
  'exam.paper.pass': 'Pass marks',
  'exam.paper.add': 'Add paper',
  'exam.paper.remove': 'Remove paper',
  'exam.action.scheduled': 'Schedule',
  'exam.action.draft': 'Back to draft',
  'exam.action.marking': 'Open for marking',
  'exam.action.marking.reopen': 'Reopen for corrections',
  'exam.action.verified': 'Mark as verified',
  'exam.action.published': 'Publish results',
  'exam.reason': 'Reason',
  'exam.history': 'History',
  'grading.none': 'No grading scales yet.',
  'grading.name': 'Scale name',
  'grading.grade': 'Grade',
  'grading.min': 'From %',
  'grading.point': 'Points',
  'grading.pass': 'Pass',
  'grading.addBand': 'Add band',
  'grading.removeBand': 'Remove band',
  'grading.create': 'Create scale',
  'results.pick': 'Choose an exam to see its results.',
  'results.preview': 'Preview: marks are not published yet.',
  'results.student': 'Student',
  'results.class': 'Class',
  'results.total': 'Total',
  'results.percentage': '%',
  'results.grade': 'Grade',
  'results.result': 'Result',
  'results.rank': 'Rank',
  'results.pass': 'Pass',
  'results.fail': 'Fail',
  'results.empty': 'No results to show.',
  'results.summary': '{students} students, {passed} passed, {failed} failed, average {average}%',
  'results.pdf': 'PDF',
  'results.pdfFor': 'Report card PDF: {name}',
  'results.incomplete': 'incomplete',
  'marks.title': 'Marks entry',
  'marks.exam': 'Exam',
  'marks.paper': 'Paper',
  'marks.choose': 'Choose…',
  'marks.noExams': 'No exams to show.',
  'marks.student': 'Student',
  'marks.section': 'Section',
  'marks.status': 'Status',
  'marks.marks': 'Marks',
  'marks.outOf': 'out of {max} (pass {pass})',
  'marks.present': 'Present',
  'marks.absent': 'Absent',
  'marks.exempt': 'Exempt',
  'marks.marksFor': 'Marks for {name}',
  'marks.statusFor': 'Status for {name}',
  'marks.save': 'Save marks',
  'marks.saved': 'Marks saved.',
  'marks.closed': 'This exam is not open for marks entry.',
  'marks.entered': '{entered} of {total} entered',
  'child.tab.results': 'Results',
  'child.results.none': 'No published results yet.',
  'child.results.rank': 'Rank {rank}',
  'nav.fees': 'Fees',
  'nav.accounting': 'Accounting',
  'fees.title': 'Fees',
  'fees.tab.structure': 'Fee structure',
  'fees.tab.invoices': 'Invoices',
  'fees.tab.payments': 'Payments',
  'fees.heads': 'Fee heads',
  'fees.headName': 'Fee head name',
  'fees.addHead': 'Add fee head',
  'fees.noHeads': 'No fee heads yet.',
  'fees.class': 'Class',
  'fees.head': 'Fee head',
  'fees.amount': 'Amount',
  'fees.dueDate': 'Due date',
  'fees.addItem': 'Add to structure',
  'fees.removeItem': 'Remove',
  'fees.noItems': 'No fees set for this class yet.',
  'fees.generate': 'Generate invoices',
  'fees.generated':
    '{created} created, {added} lines added, {upToDate} up to date, {none} without a structure, {cancelled} cancelled skipped.',
  'fees.invoice': 'Invoice',
  'fees.student': 'Student',
  'fees.total': 'Total',
  'fees.paid': 'Paid',
  'fees.balance': 'Balance',
  'fees.overdue': 'Overdue',
  'fees.status': 'Status',
  'fees.filter.all': 'All',
  'fees.filter.outstanding': 'Outstanding',
  'fees.filter.overdue': 'Overdue',
  'fees.filter.paid': 'Paid',
  'fees.filter.cancelled': 'Cancelled',
  'fees.noInvoices': 'No invoices to show.',
  'fees.view': 'View',
  'fees.lines': 'Lines',
  'fees.receipts': 'Receipts',
  'fees.adjust': 'Adjust invoice',
  'fees.adjustDescription': 'Description',
  'fees.adjustAmount': 'Amount (negative for a discount)',
  'fees.adjustApply': 'Apply adjustment',
  'fees.cancelInvoice': 'Cancel invoice',
  'fees.cancelReason': 'Reason for cancelling',
  'fees.collect': 'Collect payment',
  'fees.searchStudent': 'Find student (name or admission number)',
  'fees.pickStudent': 'Choose a student',
  'fees.owes': '{name} owes {amount}',
  'fees.method': 'Method',
  'fees.method.cash': 'Cash',
  'fees.method.cheque': 'Cheque',
  'fees.method.bank_transfer': 'Bank transfer',
  'fees.method.card': 'Card',
  'fees.method.upi': 'UPI',
  'fees.method.online': 'Online',
  'fees.reference': 'Reference',
  'fees.record': 'Record payment',
  'fees.recorded': 'Receipt {number} issued.',
  'fees.receipt': 'Receipt',
  'fees.receiptPdf': 'Receipt PDF: {number}',
  'fees.void': 'Void receipt',
  'fees.voidReason': 'Reason for voiding',
  'fees.noPayments': 'No payments yet.',
  'fees.date': 'Date',
  'fees.invalidAmount': 'Enter an amount such as 1250.50',
  'fees.statusValid': 'Valid',
  'fees.statusVoid': 'Void',
  'fees.statusIssued': 'Issued',
  'fees.statusCancelled': 'Cancelled',
  'fees.nothingDue': 'Nothing is outstanding for this student.',
  'acct.title': 'Accounting',
  'acct.tab.accounts': 'Chart of accounts',
  'acct.tab.journal': 'Journal',
  'acct.tab.reports': 'Reports',
  'acct.code': 'Code',
  'acct.name': 'Name',
  'acct.type': 'Type',
  'acct.type.asset': 'Asset',
  'acct.type.liability': 'Liability',
  'acct.type.equity': 'Equity',
  'acct.type.income': 'Income',
  'acct.type.expense': 'Expense',
  'acct.addAccount': 'Add account',
  'acct.system': 'standard',
  'acct.entries': 'Entries',
  'acct.entry': 'Entry',
  'acct.memo': 'Memo',
  'acct.debit': 'Debit',
  'acct.credit': 'Credit',
  'acct.account': 'Account',
  'acct.addLine': 'Add line',
  'acct.removeLine': 'Remove line',
  'acct.post': 'Post entry',
  'acct.posted': 'Entry {number} posted.',
  'acct.notBalanced': 'Debits and credits must be equal.',
  'acct.reverse': 'Reverse',
  'acct.reverseReason': 'Reason for reversing',
  'acct.noEntries': 'No journal entries.',
  'acct.trialBalance': 'Trial balance',
  'acct.asOf': 'As of',
  'acct.balanced': 'Balanced',
  'acct.unbalanced': 'NOT balanced',
  'acct.collections': 'Collections',
  'acct.from': 'From',
  'acct.to': 'To',
  'acct.dues': 'Outstanding dues',
  'acct.total': 'Total',
  'child.tab.fees': 'Fees',
  'child.fees.none': 'No invoices yet.',
  'child.fees.balance': 'Balance due',
  'nav.hr': 'HR and payroll',
  'nav.myHr': 'My leave and payslips',
  'hr.title': 'HR and payroll',
  'hr.tab.attendance': 'Staff attendance',
  'hr.tab.leave': 'Leave',
  'hr.tab.salaries': 'Salaries',
  'hr.tab.payroll': 'Payroll',
  'hr.date': 'Date',
  'hr.staff': 'Staff member',
  'hr.status': 'Status',
  'hr.remarks': 'Remarks',
  'hr.status.present': 'Present',
  'hr.status.absent': 'Absent',
  'hr.status.late': 'Late',
  'hr.status.half_day': 'Half day',
  'hr.status.on_leave': 'On leave',
  'hr.statusFor': 'Status for {name}',
  'hr.onLeave': 'On approved leave',
  'hr.saveAttendance': 'Save attendance',
  'hr.saved': 'Attendance saved.',
  'hr.notSchoolDay': 'Not a school day.',
  'hr.noStaff': 'No staff to show.',
  'hr.leaveTypes': 'Leave types',
  'hr.leaveTypeName': 'Name',
  'hr.annualDays': 'Days per year (blank = unlimited)',
  'hr.paid': 'Paid',
  'hr.addLeaveType': 'Add leave type',
  'hr.requests': 'Leave requests',
  'hr.noRequests': 'No leave requests.',
  'hr.days': '{days} day(s)',
  'hr.approve': 'Approve',
  'hr.reject': 'Reject',
  'hr.requestStatus.pending': 'Pending',
  'hr.requestStatus.approved': 'Approved',
  'hr.requestStatus.rejected': 'Rejected',
  'hr.requestStatus.cancelled': 'Cancelled',
  'hr.components': 'Salary components',
  'hr.componentName': 'Component name',
  'hr.kind': 'Kind',
  'hr.kind.earning': 'Earning',
  'hr.kind.deduction': 'Deduction',
  'hr.addComponent': 'Add component',
  'hr.setSalary': 'Set salary',
  'hr.effectiveFrom': 'Effective from',
  'hr.basic': 'Basic salary',
  'hr.noSalary': 'No salary set.',
  'hr.saveSalary': 'Save salary',
  'hr.salarySaved': 'Salary saved.',
  'hr.runs': 'Payroll runs',
  'hr.noRuns': 'No payroll runs yet.',
  'hr.period': 'Month (YYYY-MM)',
  'hr.prepareRun': 'Prepare run',
  'hr.openRun': 'Open',
  'hr.gross': 'Gross',
  'hr.lop': 'Loss of pay',
  'hr.deductions': 'Deductions',
  'hr.net': 'Net pay',
  'hr.unmarked': 'Unmarked days',
  'hr.recalculate': 'Recalculate',
  'hr.approveRun': 'Approve run',
  'hr.payRun': 'Record payment',
  'hr.cancelRun': 'Cancel run',
  'hr.cancelReason': 'Reason',
  'hr.payMethod': 'Payment method',
  'hr.method.bank_transfer': 'Bank transfer',
  'hr.method.cash': 'Cash',
  'hr.method.cheque': 'Cheque',
  'hr.runStatus.draft': 'Draft',
  'hr.runStatus.approved': 'Approved',
  'hr.runStatus.paid': 'Paid',
  'hr.runStatus.cancelled': 'Cancelled',
  'hr.payslip': 'Payslip',
  'hr.payslipFor': 'Payslip PDF: {name}',
  'hr.skipped': 'No salary set for: {names}',
  'hr.myLeave': 'My leave',
  'hr.balance': '{name}: {remaining} of {total} days left',
  'hr.unlimited': '{name}: unlimited',
  'hr.applyLeave': 'Apply for leave',
  'hr.leaveType': 'Leave type',
  'hr.from': 'From',
  'hr.to': 'To',
  'hr.reason': 'Reason',
  'hr.send': 'Send request',
  'hr.sent': 'Leave request sent.',
  'hr.cancelRequest': 'Cancel request',
  'hr.myPayslips': 'My payslips',
  'hr.noPayslips': 'No payslips yet.',
  'nav.library': 'Library',
  'nav.myLibrary': 'My library',
  'lib.title': 'Library',
  'lib.tab.catalogue': 'Catalogue',
  'lib.tab.circulation': 'Circulation',
  'lib.tab.fines': 'Fines',
  'lib.search': 'Search title, author or ISBN',
  'lib.availableOnly': 'Available only',
  'lib.noBooks': 'No books found.',
  'lib.copies': '{available} of {total} available',
  'lib.addBook': 'Add book',
  'lib.bookTitle': 'Title',
  'lib.author': 'Author',
  'lib.isbn': 'ISBN',
  'lib.category': 'Category',
  'lib.price': 'Price',
  'lib.copiesToAdd': 'Copies',
  'lib.bookAdded': 'Book added.',
  'lib.invalid': 'Check the highlighted fields.',
  'lib.issue': 'Issue a book',
  'lib.accession': 'Accession number',
  'lib.borrowerType': 'Borrower',
  'lib.student': 'Student',
  'lib.staff': 'Staff',
  'lib.findBorrower': 'Find borrower',
  'lib.issueBtn': 'Issue',
  'lib.issued': 'Issued. Due {date}.',
  'lib.activeLoans': 'Loans on the shelf and out',
  'lib.overdueOnly': 'Overdue only',
  'lib.noLoans': 'No loans.',
  'lib.dueOn': 'Due {date}',
  'lib.overdueDays': '{days} day(s) overdue',
  'lib.return': 'Return',
  'lib.renew': 'Renew',
  'lib.lost': 'Mark lost',
  'lib.returned': 'Returned.',
  'lib.returnedFine': 'Returned. A fine of {amount} was raised.',
  'lib.noFines': 'No fines.',
  'lib.fineFor': '{reason}: {title}',
  'lib.reason.overdue': 'Overdue',
  'lib.reason.lost': 'Lost',
  'lib.reason.damaged': 'Damaged',
  'lib.collect': 'Collect',
  'lib.waive': 'Waive',
  'lib.waiveReason': 'Reason for waiving',
  'lib.collected': 'Collected. Receipt {number}.',
  'lib.status.unpaid': 'Unpaid',
  'lib.status.paid': 'Paid',
  'lib.status.waived': 'Waived',
  'lib.myLoans': 'My loans',
  'lib.myFines': 'My fines',
  'child.tab.library': 'Library',
  'nav.transport': 'Transport',
  'child.tab.transport': 'Transport',
  'tr.title': 'Transport',
  'tr.tab.routes': 'Routes',
  'tr.tab.seats': 'Seats',
  'tr.tab.fleet': 'Fleet',
  'tr.tab.billing': 'Billing',
  'tr.invalid': 'Check the highlighted fields.',
  'tr.none': 'None',
  'tr.choose': 'Choose...',
  'tr.vehicle': 'Vehicle',
  'tr.vehicles': 'Vehicles',
  'tr.driver': 'Driver',
  'tr.drivers': 'Drivers',
  'tr.route': 'Route',
  'tr.stop': 'Stop',
  'tr.stops': 'Stops',
  'tr.noVehicles': 'No vehicles yet.',
  'tr.noDrivers': 'No drivers yet.',
  'tr.noRoutes': 'No routes yet.',
  'tr.noStops': 'This route has no stops yet.',
  'tr.noVehicle': 'No vehicle',
  'tr.noDriver': 'No driver',
  'tr.noSeats': 'No students have a seat.',
  'tr.noSeat': 'Your child does not use school transport.',
  'tr.noCharges': 'Nothing billed.',
  'tr.noWork': 'No maintenance recorded.',
  'tr.nothingDue': 'Nothing is due in the next 30 days.',
  'tr.mySeat': 'Transport seat',
  'tr.billedMonths': 'Billed months',
  'tr.cancelled': 'cancelled',
  'tr.capacity': '{n} seats',
  'tr.seatsTaken': '{taken} of {total} seats taken',
  'tr.perMonth': '{amount} per month',
  'tr.pickupAt': 'pick-up {time}',
  'tr.dropAt': 'drop {time}',
  'tr.licenceUntil': 'Licence until {date}',
  'tr.nextDue': 'next due {date}',
  'tr.inDays': 'in {days} day(s)',
  'tr.expiredDays': 'expired {days} day(s) ago',
  'tr.expiring': 'Coming due',
  'tr.expiry.vehicle_insurance': 'Insurance',
  'tr.expiry.vehicle_fitness': 'Fitness certificate',
  'tr.expiry.driver_licence': 'Driving licence',
  'tr.expiry.maintenance_due': 'Maintenance',
  'tr.type.bus': 'Bus',
  'tr.type.van': 'Van',
  'tr.type.car': 'Car',
  'tr.type.other': 'Other',
  'tr.status.active': 'Active',
  'tr.status.maintenance': 'In workshop',
  'tr.status.retired': 'Retired',
  'tr.status.inactive': 'Closed',
  'tr.work.service': 'Service',
  'tr.work.repair': 'Repair',
  'tr.work.inspection': 'Inspection',
  'tr.work.insurance': 'Insurance',
  'tr.work.other': 'Other',
  'tr.addVehicle': 'Add vehicle',
  'tr.registration': 'Registration number',
  'tr.seats': 'Seats',
  'tr.vehicleType': 'Type',
  'tr.insuranceExpiry': 'Insurance expires',
  'tr.fitnessExpiry': 'Fitness certificate expires',
  'tr.vehicleAdded': 'Vehicle added.',
  'tr.addDriver': 'Add driver',
  'tr.driverName': 'Driver name',
  'tr.phone': 'Phone',
  'tr.licenceNumber': 'Licence number',
  'tr.licenceExpiry': 'Licence expires',
  'tr.driverAdded': 'Driver added.',
  'tr.maintenance': 'Maintenance',
  'tr.addWork': 'Record work',
  'tr.workKind': 'Kind of work',
  'tr.workDate': 'Date of work',
  'tr.cost': 'Cost ({currency})',
  'tr.workDescription': 'What was done',
  'tr.nextDueLabel': 'Next due',
  'tr.workAdded': 'Maintenance recorded.',
  'tr.addRoute': 'Add route',
  'tr.routeName': 'Route name',
  'tr.routeAdded': 'Route added.',
  'tr.addStop': 'Add stop',
  'tr.stopName': 'Stop name',
  'tr.position': 'Order',
  'tr.pickup': 'Pick-up time',
  'tr.drop': 'Drop time',
  'tr.monthlyFee': 'Monthly fee ({currency})',
  'tr.stopAdded': 'Stop added.',
  'tr.giveSeat': 'Give seat',
  'tr.findStudent': 'Find student',
  'tr.seated': 'Seat given.',
  'tr.currentSeats': 'Current seats',
  'tr.filterRoute': 'Route',
  'tr.allRoutes': 'All routes',
  'tr.endSeat': 'End seat',
  'tr.confirmEnd': 'End the transport seat of {name}?',
  'tr.month': 'Month',
  'tr.monthHint': 'Students seated on the first day of the month are billed.',
  'tr.chargeMonth': 'Bill this month',
  'tr.billed':
    'Billed {count} student(s), {amount}. Already billed: {already}. Cancelled invoices skipped: {cancelled}. Free stops: {free}.',
  'nav.hostel': 'Hostel',
  'child.tab.hostel': 'Hostel',
  'ho.title': 'Hostel',
  'ho.tab.rooms': 'Rooms',
  'ho.tab.residents': 'Residents',
  'ho.tab.outpasses': 'Out-passes',
  'ho.tab.visitors': 'Visitors',
  'ho.tab.billing': 'Billing',
  'ho.choose': 'Choose...',
  'ho.hostel': 'Hostel',
  'ho.room': 'Room',
  'ho.rooms': 'Rooms',
  'ho.allHostels': 'All hostels',
  'ho.noHostels': 'No hostels yet.',
  'ho.noRooms': 'This hostel has no rooms yet.',
  'ho.noResidents': 'Nobody lives in the hostel.',
  'ho.noPasses': 'No out-passes.',
  'ho.noVisitors': 'No visitors.',
  'ho.noCharges': 'Nothing billed.',
  'ho.noBed': 'Your child does not live in the hostel.',
  'ho.myBed': 'Hostel bed',
  'ho.billedMonths': 'Billed months',
  'ho.cancelled': 'cancelled',
  'ho.closed': 'closed',
  'ho.maintenance': 'under maintenance',
  'ho.residents.boys': 'Boys',
  'ho.residents.girls': 'Girls',
  'ho.residents.mixed': 'Mixed',
  'ho.wardenIs': 'warden {name}',
  'ho.bedsTaken': '{taken} of {total} beds taken',
  'ho.perMonth': '{amount} per month',
  'ho.roomLabel': 'Room {number}',
  'ho.floorLabel': 'floor {floor}',
  'ho.addHostel': 'Add hostel',
  'ho.hostelName': 'Hostel name',
  'ho.takes': 'Takes',
  'ho.hostelAdded': 'Hostel added.',
  'ho.addRoom': 'Add room',
  'ho.roomNumber': 'Room number',
  'ho.floor': 'Floor',
  'ho.beds': 'Beds',
  'ho.monthlyFee': 'Monthly fee per bed ({currency})',
  'ho.roomAdded': 'Room added.',
  'ho.giveBed': 'Give bed',
  'ho.findStudent': 'Find student',
  'ho.chooseStudent': 'Choose a student from the list.',
  'ho.bedGiven': 'Bed given.',
  'ho.residentsTitle': 'Residents',
  'ho.endBed': 'End bed',
  'ho.confirmEnd': 'End the hostel bed of {name}?',
  'ho.recordPass': 'Record out-pass',
  'ho.expectedBack': 'Expected back',
  'ho.reason': 'Reason',
  'ho.escort': 'Escort (optional)',
  'ho.passRecorded': 'Out-pass recorded.',
  'ho.passes': 'Out-passes',
  'ho.lateOnly': 'Late only',
  'ho.statusOut': 'out',
  'ho.lateDays': '{days} day(s) late',
  'ho.markBack': 'Mark back',
  'ho.returnedOk': 'Marked as back.',
  'ho.signIn': 'Sign visitor in',
  'ho.visiting': 'Visiting student',
  'ho.visitorName': 'Visitor name',
  'ho.relationship': 'Relationship',
  'ho.phone': 'Phone',
  'ho.visitorIn': 'Visitor signed in.',
  'ho.visitorBook': 'Visitor book',
  'ho.insideOnly': 'Inside now',
  'ho.signOut': 'Sign out',
  'ho.month': 'Month',
  'ho.monthHint': 'Students with a bed on the first day of the month are billed.',
  'ho.chargeMonth': 'Bill this month',
  'ho.billed':
    'Billed {count} student(s), {amount}. Already billed: {already}. Cancelled invoices skipped: {cancelled}. Free rooms: {free}.',
  'nav.inventory': 'Inventory',
  'inv.title': 'Inventory and assets',
  'inv.tab.stock': 'Stock',
  'inv.tab.suppliers': 'Suppliers',
  'inv.tab.assets': 'Assets',
  'inv.choose': 'Choose...',
  'inv.chooseOne': 'Choose one from the list.',
  'inv.invalid': 'Check the highlighted fields.',
  'inv.search': 'Search name or SKU',
  'inv.lowOnly': 'Low stock only',
  'inv.noItems': 'No items.',
  'inv.onHand': '{n} {unit} on hand',
  'inv.low': 'low',
  'inv.addItem': 'Add item',
  'inv.sku': 'SKU',
  'inv.itemName': 'Item name',
  'inv.unit': 'Unit',
  'inv.category': 'Category',
  'inv.reorder': 'Reorder level',
  'inv.itemAdded': 'Item added.',
  'inv.receive': 'Receive stock',
  'inv.item': 'Item',
  'inv.supplier': 'Supplier',
  'inv.quantity': 'Quantity received',
  'inv.unitCost': 'Unit cost ({currency})',
  'inv.reference': 'Invoice or reference',
  'inv.received': 'Stock received.',
  'inv.issue': 'Issue stock',
  'inv.issueItem': 'Item to issue',
  'inv.issueQuantity': 'Quantity issued',
  'inv.issuedTo': 'Issued to',
  'inv.issued': 'Stock issued.',
  'inv.adjust': 'Adjust stock',
  'inv.adjustItem': 'Item to adjust',
  'inv.change': 'Change in quantity',
  'inv.changeHint': 'Positive adds, negative writes off.',
  'inv.gainCost': 'Unit cost of stock added ({currency}, optional)',
  'inv.reason': 'Reason',
  'inv.adjusted': 'Stock adjusted.',
  'inv.recent': 'Recent movements',
  'inv.noMovements': 'No movements yet.',
  'inv.kind.receipt': 'Received',
  'inv.kind.issue': 'Issued',
  'inv.kind.adjustment': 'Adjusted',
  'inv.noSuppliers': 'No suppliers yet.',
  'inv.owed': 'owed {amount}',
  'inv.pay': 'Pay',
  'inv.payForm': 'Pay supplier',
  'inv.amount': 'Amount ({currency})',
  'inv.method': 'Method',
  'inv.payNow': 'Pay now',
  'inv.paid': 'Payment recorded.',
  'inv.addSupplier': 'Add supplier',
  'inv.supplierName': 'Supplier name',
  'inv.contact': 'Contact person',
  'inv.phone': 'Phone',
  'inv.supplierAdded': 'Supplier added.',
  'inv.noAssets': 'No assets registered.',
  'inv.assetSummary':
    '{count} asset(s), cost {cost}, depreciation {depreciation}, net book value {nbv}.',
  'inv.nbv': 'worth {nbv} of {cost}',
  'inv.assetStatus.in_use': 'in use',
  'inv.assetStatus.in_store': 'in store',
  'inv.assetStatus.under_repair': 'under repair',
  'inv.assetStatus.disposed': 'disposed',
  'inv.dispose': 'Dispose',
  'inv.disposeForm': 'Dispose of asset',
  'inv.proceeds': 'Proceeds ({currency})',
  'inv.disposeNote': 'Why',
  'inv.disposeNow': 'Dispose now',
  'inv.disposed': 'Asset disposed.',
  'inv.month': 'Month',
  'inv.monthHint': 'Every asset in service is depreciated up to this month.',
  'inv.runDepreciation': 'Run depreciation',
  'inv.depreciated': 'Depreciated {count} asset(s), {amount}. Already done: {already}.',
  'inv.addAsset': 'Register asset',
  'inv.assetName': 'Asset name',
  'inv.purchaseDate': 'Purchase date',
  'inv.cost': 'Cost ({currency})',
  'inv.salvage': 'Salvage value ({currency})',
  'inv.lifeMonths': 'Useful life (months)',
  'inv.assetAdded': 'Asset registered.',
  'nav.notices': 'Notices',
  'nav.inbox': 'Inbox',
  'cm.title': 'Notices',
  'cm.titleField': 'Title',
  'cm.tab.announcements': 'Announcements',
  'cm.tab.deliveries': 'Delivery log',
  'cm.none': 'No announcements yet.',
  'cm.status.draft': 'draft',
  'cm.status.scheduled': 'scheduled',
  'cm.status.published': 'sent',
  'cm.status.cancelled': 'cancelled',
  'cm.audience': 'Send to',
  'cm.audience.parents': 'All parents',
  'cm.audience.staff': 'All staff',
  'cm.audience.everyone': 'Everyone',
  'cm.audience.class': 'Parents of a class',
  'cm.audience.student': 'Parents of one student',
  'cm.class': 'Class',
  'cm.student': 'Student',
  'cm.choose': 'Choose...',
  'cm.email': 'Email',
  'cm.sms': 'SMS',
  'cm.inApp': 'In-app notification',
  'cm.channels': 'Also send by',
  'cm.sendsAt': 'sends {time}',
  'cm.publishNow': 'Send now',
  'cm.confirmSend': 'Send "{title}" now? A sent announcement cannot be called back.',
  'cm.schedule': 'Schedule',
  'cm.scheduleForm': 'Schedule announcement',
  'cm.sendAt': 'Send at',
  'cm.scheduleNow': 'Schedule it',
  'cm.cancel': 'Cancel',
  'cm.delete': 'Delete',
  'cm.published': 'Announcement sent.',
  'cm.scheduled': 'Announcement scheduled.',
  'cm.cancelled': 'Announcement cancelled.',
  'cm.deleted': 'Announcement deleted.',
  'cm.saved': 'Draft saved.',
  'cm.compose': 'Write an announcement',
  'cm.body': 'Message',
  'cm.saveDraft': 'Save draft',
  'cm.reach': 'This reaches {people} people: {inApp} in-app, {email} by email, {sms} by SMS.',
  'cm.emailOff': 'Email is switched off for this school.',
  'cm.smsOff': 'SMS is switched off for this school.',
  'cm.statusFilter': 'Status',
  'cm.channelFilter': 'Channel',
  'cm.any': 'Any',
  'cm.delivery.pending': 'waiting',
  'cm.delivery.sending': 'sending',
  'cm.delivery.sent': 'sent',
  'cm.delivery.failed': 'failed',
  'cm.delivery.cancelled': 'stopped',
  'cm.attempts': '{n} attempt(s)',
  'cm.retry': 'Retry',
  'cm.stop': 'Stop',
  'cm.sendQueued': 'Send waiting messages now',
  'cm.dispatched': 'Sent {sent}, will retry {retrying}, gave up on {failed}.',
  'cm.noDeliveries': 'No messages.',
  'cm.inbox': 'Inbox',
  'cm.unread': '{n} unread',
  'cm.unreadOnly': 'Unread only',
  'cm.markAllRead': 'Mark all read',
  'cm.markRead': 'Mark read',
  'cm.emptyInbox': 'Nothing here yet.',
  'cm.preferences': 'How we contact you',
  'cm.preferencesHint':
    'In-app notifications are always kept. You can turn email and SMS off here.',
  'cm.receiveEmail': 'Send me notices by email',
  'cm.receiveSms': 'Send me notices by SMS',
  'nav.documents': 'Documents',
  'nav.certificates': 'Certificates',
  'doc.title': 'Documents',
  'doc.owner.student': 'Student',
  'doc.owner.staff': 'Staff member',
  'doc.search.student': 'Find a student (name or admission number)',
  'doc.search.staff': 'Find a staff member (name or employee number)',
  'doc.pick': 'Choose someone to see their documents.',
  'doc.upload': 'Add a document',
  'doc.file': 'File (PDF, PNG or JPEG)',
  'doc.category': 'Category',
  'doc.titleField': 'Title (optional)',
  'doc.visible': 'Show to parents',
  'doc.add': 'Upload',
  'doc.uploaded': 'Document uploaded.',
  'doc.empty': 'No documents yet.',
  'doc.noFile': 'Choose a file first.',
  'doc.status.pending': 'Waiting for review',
  'doc.status.verified': 'Verified',
  'doc.status.rejected': 'Rejected',
  'doc.cat.birth_certificate': 'Birth certificate',
  'doc.cat.id_proof': 'ID proof',
  'doc.cat.address_proof': 'Address proof',
  'doc.cat.transfer_certificate': 'Transfer certificate',
  'doc.cat.medical': 'Medical',
  'doc.cat.photo': 'Photo',
  'doc.cat.qualification': 'Qualification',
  'doc.cat.contract': 'Contract',
  'doc.cat.other': 'Other',
  'doc.download': 'Download',
  'doc.verify': 'Verify',
  'doc.reject': 'Reject',
  'doc.rejectReason': 'Reason for rejecting',
  'doc.confirmReject': 'Confirm rejection',
  'doc.delete': 'Delete',
  'doc.confirmDelete': 'Delete this document? The file is removed for good.',
  'doc.parentsSee': 'Visible to parents',
  'doc.hideFromParents': 'Hide from parents',
  'doc.showToParents': 'Show to parents',
  'doc.size': '{kb} KB',
  'cert.title': 'Certificates',
  'cert.tab.register': 'Register',
  'cert.tab.requests': 'Requests',
  'cert.tab.issue': 'Issue',
  'cert.type.bonafide': 'Bonafide (enrolment) certificate',
  'cert.type.character': 'Character certificate',
  'cert.type.transfer': 'Transfer certificate',
  'cert.type.fee_clearance': 'Fee clearance certificate',
  'cert.type': 'Kind',
  'cert.student': 'Find a student (name or admission number)',
  'cert.purpose': 'Purpose (optional)',
  'cert.printedName': 'Name to print (only if the record has letters the PDF cannot draw)',
  'cert.leavingDate': 'Leaving date',
  'cert.reason': 'Reason for leaving',
  'cert.conduct': 'Conduct',
  'cert.issue': 'Issue certificate',
  'cert.issued': 'Certificate {number} issued.',
  'cert.number': 'Number',
  'cert.code': 'Verification code',
  'cert.status.issued': 'Valid',
  'cert.status.revoked': 'Revoked',
  'cert.pdf': 'PDF',
  'cert.revoke': 'Revoke',
  'cert.revokeReason': 'Reason for revoking',
  'cert.confirmRevoke': 'Confirm revoke',
  'cert.empty': 'No certificates yet.',
  'cert.search': 'Search by number',
  'cert.req.empty': 'No requests.',
  'cert.req.status.pending': 'Waiting',
  'cert.req.status.approved': 'Approved',
  'cert.req.status.rejected': 'Declined',
  'cert.req.status.cancelled': 'Withdrawn',
  'cert.approve': 'Approve and issue',
  'cert.decline': 'Decline',
  'cert.declineReason': 'Reason for declining',
  'cert.confirmDecline': 'Confirm decline',
  'cert.decided': 'Request updated.',
  'cert.request': 'Ask for a certificate',
  'cert.requestSent': 'Request sent to the school.',
  'cert.send': 'Send request',
  'cert.withdraw': 'Withdraw',
  'cert.mine': 'Certificates issued',
  'cert.myRequests': 'My requests',
  'cert.noneMine': 'No certificates have been issued yet.',
  'cert.noRequests': 'No requests yet.',
  'child.tab.documents': 'Documents',
  'child.documents': 'Documents shared by the school',
  'child.noDocuments': 'The school has not shared any documents.',
  'verify.title': 'Check a certificate',
  'verify.intro': 'Type the verification code printed on the certificate.',
  'verify.code': 'Verification code',
  'verify.check': 'Check',
  'verify.valid': 'This certificate is genuine.',
  'verify.revoked': 'This certificate was revoked and is no longer valid.',
  'verify.notFound': 'No certificate matches this code.',
  'verify.badCode': 'That is not a valid verification code.',
  'verify.issuedBy': 'Issued by {school} on {date}',
  'verify.holder': 'Holder',
  'verify.kind': 'Kind',
  'verify.number': 'Number',
  'nav.reports': 'Reports',
  'rep.title': 'Reports',
  'rep.pick': 'Report',
  'rep.class': 'Class',
  'rep.allClasses': 'All classes',
  'rep.from': 'From',
  'rep.to': 'To',
  'rep.groupBy': 'Group by',
  'rep.byDay': 'Day',
  'rep.byMonth': 'Month',
  'rep.run': 'Show report',
  'rep.csv': 'Download CSV',
  'rep.none': 'You cannot open any report at this school.',
  'rep.empty': 'Nothing to report for these choices.',
  'rep.generated': 'Prepared {time}',
  'rep.academicYear': 'Academic year: {name}',
  'rep.range': 'From {from} to {to}',
  'search.label': 'Search',
  'search.placeholder': 'Search students, staff, guardians, invoices…',
  'search.none': 'Nothing found.',
  'search.type.student': 'Students',
  'search.type.staff': 'Staff',
  'search.type.guardian': 'Guardians',
  'search.type.invoice': 'Invoices',
  'search.type.certificate': 'Certificates',
  'dash.unread': 'You have {n} unread notification(s).',
  'dash.inbox': 'Open inbox',
  'dash.students': 'Active students',
  'dash.attendance': 'Attendance today',
  'dash.attendanceLine': '{marked} marked: {present} present, {absent} absent, {late} late',
  'dash.registers': '{done} of {total} registers submitted',
  'dash.fees': 'Fees',
  'dash.collected': 'Collected this month',
  'dash.outstanding': 'Outstanding',
  'dash.overdue': 'Overdue',
  'dash.waiting': 'Waiting for you',
  'dash.documentsToReview': 'Documents to review',
  'dash.certificateRequests': 'Certificate requests',
  'dash.studentLeave': 'Student leave requests',
  'dash.staffLeave': 'Staff leave requests',
  'dash.openApplications': 'Open admission applications',
  'dash.failedMessages': 'Failed messages',
  'dash.nothingWaiting': 'Nothing is waiting.',
  'dash.noSchools': 'Nothing to show for your role yet.',
  'auth.mfaTitle': 'Two-step sign-in',
  'auth.mfaIntro': 'Enter the 6-digit code from your authenticator app.',
  'auth.mfaRecoveryIntro': 'Enter one of your recovery codes. Each one works only once.',
  'auth.mfaCodeLabel': 'Code from your authenticator app',
  'auth.mfaRecoveryLabel': 'Recovery code',
  'auth.mfaVerify': 'Verify',
  'auth.mfaUseRecovery': 'Use a recovery code instead',
  'auth.mfaUseApp': 'Use the authenticator app instead',
  'auth.mfaBack': 'Start again',
  'auth.mfaWrong':
    'That code is not correct. A code works only once; wait for the next one if you just used it.',
  'auth.mfaExpired': 'That sign-in timed out. Please enter your password again.',
  'nav.account': 'Account',
  'account.title': 'Account and security',
  'account.mfa.title': 'Two-step sign-in',
  'account.mfa.unavailable':
    'Two-step sign-in is not set up on this server. Ask your administrator.',
  'account.mfa.off': 'Off. Your password is the only thing protecting this account.',
  'account.mfa.on': 'On. Signing in asks for a code from your authenticator app.',
  'account.mfa.codesLeft': '{n} recovery code(s) left',
  'account.mfa.start': 'Set up two-step sign-in',
  'account.mfa.confirmPassword': 'Your password',
  'account.mfa.begin': 'Continue',
  'account.mfa.scan':
    'Add this account to your authenticator app (choose “enter a setup key”, time-based), then type the 6-digit code it shows.',
  'account.mfa.key': 'Setup key',
  'account.mfa.address': 'Or open this address on the device with the app',
  'account.mfa.code': '6-digit code',
  'account.mfa.enable': 'Turn on',
  'account.mfa.cancel': 'Cancel',
  'account.mfa.saved': 'Two-step sign-in is on. Your other devices were signed out.',
  'account.mfa.recoveryTitle': 'Save your recovery codes',
  'account.mfa.recoveryWarning':
    'Each code works once if you lose your phone. They are shown only now: write them down or store them in a password manager.',
  'account.mfa.recoveryDone': 'I have saved them',
  'account.mfa.replace': 'Get new recovery codes',
  'account.mfa.replaceHint': 'The old ones stop working. Needs your password and a current code.',
  'account.mfa.disable': 'Turn off two-step sign-in',
  'account.mfa.disableHint':
    'Needs your password and a code (or a recovery code). Your other devices will be signed out.',
  'account.mfa.recoveryField': 'Recovery code instead of a code',
  'account.mfa.disabled': 'Two-step sign-in is off.',
  'account.pw.title': 'Change password',
  'account.pw.current': 'Current password',
  'account.pw.new': 'New password',
  'account.pw.change': 'Change password',
  'account.pw.changed': 'Password changed. Your other devices were signed out.',
  'account.sessions.title': 'Where you are signed in',
  'account.sessions.current': 'This device',
  'account.sessions.last': 'Last used {time}',
  'account.sessions.signOut': 'Sign out',
  'account.sessions.empty': 'No other devices.',
  'nav.homework': 'Homework',
  'nav.messages': 'Messages',
  'child.tab.homework': 'Homework',
  'hw.title': 'Homework',
  'hw.list': 'Homework set',
  'hw.add': 'Set homework',
  'hw.empty': 'No homework has been set yet.',
  'hw.col.title': 'Title',
  'hw.col.class': 'Class',
  'hw.col.subject': 'Subject',
  'hw.col.due': 'Due',
  'hw.col.done': 'Handed in',
  'hw.closed': 'Closed',
  'hw.open': 'Open',
  'hw.hide': 'Hide',
  'hw.actions': 'Actions',
  'hw.section': 'Class and section',
  'hw.subject': 'Subject',
  'hw.choose': 'Choose…',
  'hw.titleLabel': 'Title',
  'hw.dueDate': 'Due date',
  'hw.instructions': 'Instructions',
  'hw.create': 'Set homework',
  'hw.created': 'Homework set.',
  'hw.roll': 'Roll',
  'hw.student': 'Student',
  'hw.status': 'Status',
  'hw.feedback': 'Feedback',
  'hw.save': 'Save',
  'hw.saved': 'Saved.',
  'hw.close': 'Close homework',
  'hw.reopen': 'Reopen',
  'hw.delete': 'Delete',
  'hw.status.pending': 'Not handed in',
  'hw.status.submitted': 'Handed in',
  'hw.status.late': 'Handed in late',
  'hw.status.excused': 'Excused',
  'hw.status.missing': 'Missing',
  'hw.none': 'No homework has been set for this class yet.',
  'hw.openCount': '{n} to do',
  'hw.overdue': 'overdue',
  'hw.markDone': 'I have done this',
  'msg.title': 'Messages',
  'msg.new': 'New message',
  'msg.threads': 'Conversations',
  'msg.conversation': 'Conversation',
  'msg.messages': 'Messages in this conversation',
  'msg.empty': 'No conversations yet.',
  'msg.pick': 'Choose a conversation.',
  'msg.unread': 'New',
  'msg.you': 'You',
  'msg.reply': 'Reply',
  'msg.send': 'Send',
  'msg.about': 'About',
  'msg.change': 'Change',
  'msg.findStudent': 'Find a student (name or admission number)',
  'msg.to': 'To',
  'msg.noRecipients': 'There is nobody to write to about this student yet.',
  'msg.subject': 'Subject',
  'msg.body': 'Message',
  'home.title': 'Everything you can do',
  'home.open': 'Open',
  'home.desc./notices': 'Announcements to parents, staff and classes',
  'home.desc./documents': 'Student documents and their review',
  'home.desc./certificates': 'Certificate requests and issued certificates',
  'home.desc./reports': 'Reports and exports',
  'home.desc./my-children': 'Attendance, timetable, results, fees and homework of your children',
  'home.desc./homework': 'Set homework and record who has handed it in',
  'home.desc./messages': 'Talk to teachers and parents about a student',
  'home.desc./my-classes': 'The classes you teach and their students',
  'home.desc./students': 'Student records, guardians and enrolment',
  'home.desc./attendance': 'Daily registers and attendance reports',
  'home.desc./library': 'Catalogue, loans and fines',
  'home.desc./my-library': 'Books you have borrowed',
  'home.desc./transport': 'Vehicles, routes, stops and seats',
  'home.desc./hostel': 'Hostels, rooms, residents and out-passes',
  'home.desc./inventory': 'Stores, stock movements and assets',
  'home.desc./hr': 'Staff attendance, leave and payroll',
  'home.desc./my-hr': 'Your leave and payslips',
  'home.desc./fees': 'Fee structure, invoices and receipts',
  'home.desc./accounting': 'Ledger, journal and trial balance',
  'home.desc./exams': 'Exams, papers and results',
  'home.desc./marks': 'Enter and review marks',
  'home.desc./timetable': 'Bell schedule and weekly timetable',
  'home.desc./my-timetable': 'Your lessons this week',
  'home.desc./leave-requests': 'Student leave requests',
  'home.desc./academics': 'Classes, subjects, houses, terms and calendar',
  'home.desc./admissions': 'Enquiries, applications and admissions',
  'home.desc./staff': 'Staff records and their logins',
  'home.desc./users': 'Sign-in accounts and roles',
  'home.desc./schools': 'Schools, campuses and academic years',
  'home.desc./settings': 'School settings',
  'home.desc./organization': 'Organization details',
  'home.desc./audit': 'Who changed what, and when',
} as const;

export type MessageKey = keyof typeof en;
